import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { useLeaveType } from '../../../hooks/CompanyConfiguration/useLeaveType'
import { rankOptions } from '../../../shared/constants'
import CustomAddForm from './CustomAddForm'

function TotalLeaveFormComp({ state, setState }) {
  const { rank, leaveAllocated, leaveType } = state
  const { getAllLeaveType } = useLeaveType()
  const { leaveType: leaveTypes } = useContext(ConfigurationContext)

  useEffect(() => {
    getAllLeaveType()
  }, [])
  const data = [
    { label: 'Leave Type', value: leaveType, name: 'leaveType', select: true, options: leaveTypes, fieldName: 'name', fieldValue: '_id' },
    { label: 'Rank', value: rank, name: 'rank', select: true, options: rankOptions, fieldName: 'label', fieldValue: 'value' },
    { label: 'Leave Allocated', value: leaveAllocated, name: 'leaveAllocated', number: true },
  ]
  return <CustomAddForm state={state} setState={setState} data={data} />
}

export default TotalLeaveFormComp
